/** Minimum gap (px) kept between a fixed-position popover and the
 * viewport edge so options/calendars never sit flush against the
 * screen on narrow phone widths. Shared by `TkticSelect`,
 * `TkticMultiSelect`, and `TkticDateInput`. */
export const POPOVER_VIEWPORT_PAD = 8;
